import { Box, Typography } from "@mui/material";
import React from "react";
import CommonLinearProgress from "../../../component/Linearprogress";
import { CustomDiv } from "../../../modules/chat-bot/style";
import { CommonGrid2 } from "../../../modules/common-components/StyledComponents";
import { CustomTooltipField } from "../../../modules/jobs/style";
import {
  FileContainer,
  StyledLinearContainer,
} from "../../../modules/matches/quick-match/components/StyledComponent";
import { GetFileIcon } from "../../../utils/constants";

const RenderResumeFiles = ({ resumeIntelligence, title }) => {
  return (
    <>
      <Typography
        variant="h6"
        fontSize={"15px"}
        fontWeight={700}
        color="#7F56D9"
        margin={"-15px 0px 5px"}
      >
        {title}
      </Typography>

      {resumeIntelligence?.map((file, index) => (
        <FileContainer
          key={index}
          elevation={1}
          gap={"1rem"}
          padding="10px"
          alignItems="center"
        >
          <Box display={"flex"} alignItems={"flex-start"} width={"25px"}>
            <GetFileIcon file={file} />
          </Box>
          <Box width={"100%"}>
            <Typography
              color="#344054"
              fontSize={"12px"}
              fontWeight={700}
              style={{
                wordBreak: "break-word",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "230px",
              }}
            >
              {file.name}
            </Typography>
            <Typography color="#475467" fontSize={"12px"} fontWeight={500}>
              {file.size}
            </Typography>
            {resumeIntelligence?.jsonResponse?.data?.id && (
              <Typography color="green" fontSize={"12px"} fontWeight={700}>
                {resumeIntelligence.jsonResponse?.message}
              </Typography>
            )}
            <div style={{ position: "relative" }}>
              {file.progress >= 0 && (
                <StyledLinearContainer>
                  <CommonLinearProgress
                    variant={
                      file.progress && !file.visible ? "buffer" : "determinate"
                    }
                    value={file.progress}
                    valueBuffer={file.buffer}
                    height={"8px"}
                    borderRadius={"2px"}
                    backgroundColor={"#E0E0E0"}
                    barbackgroundColor={file.visible ? "red" : "#7F56D9"}
                    dashedmarginTop={"2px"}
                    dashedbackgroundImage={
                      file.visible
                        ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                        : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                    }
                  />
                  <Typography
                    color="#344054"
                    fontSize={"12px"}
                    fontWeight={500}
                  >
                    {file.progress}%
                  </Typography>
                </StyledLinearContainer>
              )}
              {file.visible && (
                <CustomTooltipField size={7} fontWeight={600}>
                  {"Something went wrong"}
                </CustomTooltipField>
              )}
            </div>
          </Box>
        </FileContainer>
      ))}
    </>
  );
};

const ResumeIntelligenceToast = ({ resumeIntelligence, title }) => {
  return (
    <div>
      <RenderResumeFiles
        resumeIntelligence={resumeIntelligence}
        title={title}
      />
    </div>
  );
};

export default ResumeIntelligenceToast;

export function WorkFlowManagementToast({ files, title }) {
  return (
    <CommonGrid2 flexDirection={"column"} display={"flex"}>
      <Typography
        variant="h6"
        fontSize={"15px"}
        fontWeight={700}
        color="#7F56D9"
        margin={"-15px 0px 5px"}
      >
        {title}
      </Typography>
      <FileContainer
        elevation={1}
        padding="10px"
        gap="1rem"
        alignItems="center"
        sx={{ flexDirection: "column" }}
      >
        {files &&
          files.map((file) => (
            <Box width={"100%"}>
              <CommonGrid2
                display={"flex"}
                flexDirection={"column"}
                gap={"5px"}
              >
                <Typography
                  color="#344054"
                  fontSize={"12px"}
                  fontWeight={700}
                  style={{
                    wordBreak: "break-word",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "230px",
                  }}
                >
                  {file.name || file.job_title}
                </Typography>
                <Typography fontSize={"12px"} fontWeight={500}>
                  Job ID - {file.unique_id}
                </Typography>
              </CommonGrid2>
              {file.progress === 100 ? (
                <Typography
                  color="green"
                  fontSize={"12px"}
                  fontWeight={700}
                  marginTop={"5px"}
                >
                  {"Updated Successfully"}
                </Typography>
              ) : (
                <CustomDiv position="relative" margin="5px 0px 0px">
                  {file.progress >= 0 && (
                    <StyledLinearContainer>
                      <CommonLinearProgress
                        variant={!file.visible ? "buffer" : "determinate"}
                        value={file.progress}
                        valueBuffer={file.progress}
                        height={"8px"}
                        borderRadius={"2px"}
                        backgroundColor={"#E0E0E0"}
                        barbackgroundColor={file.visible ? "red" : "#7F56D9"}
                        dashedmarginTop={"2px"}
                        dashedbackgroundImage={
                          file.visible
                            ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                            : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                        }
                      />
                      <Typography
                        color="#344054"
                        fontSize={"12px"}
                        fontWeight={500}
                      >
                        {file.progress}%
                      </Typography>
                    </StyledLinearContainer>
                  )}
                  {file.visible && (
                    <CustomTooltipField size={7} fontWeight={600}>
                      {"Something went wrong"}
                    </CustomTooltipField>
                  )}
                </CustomDiv>
              )}
            </Box>
          ))}
      </FileContainer>
    </CommonGrid2>
  );
}

export function SowEnrichToast({ resumeIntelligence, title }) {
  return (
    <div>
      <RenderResumeFiles
        resumeIntelligence={resumeIntelligence}
        title={title}
      />
    </div>
  );
}
